import {v4 as uuidv4} from 'uuid'



export default {
  create(data) {    
    if(data.validationError) {
      data.title = 'Attention'
      data.message = 'Please fill all the required fields'
    }

    const parent = document.querySelector('.notifications');
    const dummy = document.createElement('div')
          dummy.classList.add('notification__content')
          dummy.id = uuidv4()

    const dummyTitle = document.createElement('div')
          dummyTitle.classList.add('title')
          dummyTitle.classList.add('middle')
          dummyTitle.classList.add('notification__title')
          dummyTitle.innerHTML = data.title
    
    const dummyMessage = document.createElement('p')
          dummyMessage.classList.add('desc')
          dummyMessage.classList.add('notification__desc')
          dummyMessage.innerHTML = data.message

    const dummyButton = document.createElement('button')
          dummyButton.classList.add('button')
          dummyButton.classList.add('simple')
          dummyButton.classList.add('notification__button')

    const dummyButtonSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
          dummyButtonSvg.setAttribute('width', '20px')
          dummyButtonSvg.setAttribute('height', '20px')

    const dummyButtonUse = document.createElementNS('http://www.w3.org/2000/svg', 'use')
          dummyButtonUse.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-close')
          
    parent.appendChild(dummy)
    dummy.appendChild(dummyTitle)
    dummy.appendChild(dummyMessage)
    dummy.appendChild(dummyButton)
    dummyButton.appendChild(dummyButtonSvg)
    dummyButtonSvg.appendChild(dummyButtonUse)

    function setFadeout() {
      dummyButton.removeEventListener('click', closeButton)
      dummy.classList.add('fadeout')
      dummy.addEventListener('animationend', function(e) {
        this.remove()
      })
      window.setTimeout(() => {
        if(dummy) dummy.remove()
      }, 3000)
    }

    function closeButton() {
      setFadeout()
    }

    dummyButton.addEventListener('click', closeButton)

    window.setTimeout(() => {
      setFadeout()
    }, 4000)
  }
}